import _ from 'lodash';
import { Icon, Popover } from 'antd';
import React, { Component } from 'react';
import Button from '../../views/StyledButton';
import { HelpText } from '../../views/typography';
import queryMediaStore from './queryMediaStore';
import Table from '../../views/StyledTable';
import { Results } from './queryTabStyle';

const tableConfig = {
  rowKey: 'mediaId',
  pagination: false,
  scroll: { x: true },
};

function plusOne(n) {
  if (!_.isNumber(n)) {
    return 1;
  }
  return n + 1;
}

const BOUND_FUNCTIONS = ['updateQuery'];

export default class MediaDisplay extends Component {
  constructor(props) {
    super(props);
    this.store = queryMediaStore(props);
    this.state = {
      ...this.store.state,
    };

    BOUND_FUNCTIONS.forEach((fn) => {
      if (this[fn] && _.isFunction(this[fn])) {
        this[fn] = this[fn].bind(this);
      } else {
        console.log('cannot find function ', fn);
      }
    });
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    // Are we adding new items to the list?
    // Capture the scroll position so we can adjust scroll later.
    if (prevProps.query !== this.props.query) {
      return this.props.query;
    }
    return null;
  }

  componentDidMount() {
    this._stateSub = this.store
      .subscribe((store) => {
        this.setState(state => ({ ...state, ...store.state }));
      }, (err) => {
        console.log('error on store: ', err);
        this.store.restart();
      }, () => {
        console.log('end of subscribe');
      });
  }

  componentWillUnmount() {
    if (this._stateSub) {
      this._stateSub.unsubscribe();
    }
  }

  componentDidUpdate(prevProps, prevState, query) {
    // If we have a snapshot value, we've just added new items.
    // Adjust scroll so these new items don't push the old ones out of view.
    // (snapshot here is the value returned from getSnapshotBeforeUpdate)
    if (query !== null) {
      console.log('media display update: ', query);
      this.store.actions.chooseQuery(query);
    }
  }

  async updateQuery() {
    const { query } = this.props;
    await this.store.actions.updateQuery(query);
    console.log('MediaDisplay: getting Query from tab', query);
  }

  render() {
    const {
      totalResults, media, page, ranOnce,
      queryModel, medCols, mediaLoadError,
      atStart, atEnd, querySynced,
    } = this.store.state;

    const {
      prevPage, nextPage,
    } = this.store.actions;

    return (
      <Results className="section-results">
        <Results.Header>
          <h2>Results</h2>
          {((ranOnce) && !querySynced) ? <Popover
            placement="top"
            overlayClassName="tight-popover"
            overlayStyle={({
              maxWidth: 400,
            })}
            content={<div style={({ padding: 10 })}>
              <p>
              You are currently viewing the result of query
              </p>
              <code>{queryModel.query}</code>
              <p>which is different from the query you are editing.</p>
              <p>Click to view results based on the query you are editing.</p>
            </div>}
          >   <Button
            size="small"
            type="primary"
            className="main-button"
            disabled={!queryModel.query}
            onClick={this.updateQuery}
          > <Icon type="info-circle" twoToneColor="#FF0000" theme="twoTone" />
            {' '}
            Synchronize Query
          </Button>
                                         </Popover> :
          <Button
            size="small"
            type="primary"
            className="main-button"
            disabled={!queryModel.query}
            onClick={this.updateQuery}
          >{ranOnce ? 'Re-run ' : 'Run '} Query
          </Button>}
          <Button
            size="small"
            disabled={atStart}
            icon="double-left"
            onClick={prevPage}
          />
          <div className="count">
            {media && media.length ? plusOne(page) : 1}
          </div>
          <Button
            size="small"
            disabled={atEnd}
            icon="double-right"
            onClick={nextPage}
          />
        </Results.Header>
        <div className="media-table">
          <Table dataSource={media} columns={medCols} {...tableConfig} />
        </div>
        {(media && media.length) ? (
          <HelpText style={({ textAlign: 'center' })}>
            Viewing <b>{media.length}</b> of <b>{totalResults}</b> rows {' '}
            {queryModel.limit ? <span><b>{queryModel.limit}</b> at a time</span> : ''} {' '}
            {queryModel.offset ? <span>starting from <b>{queryModel.offset + 1}</b></span> : ''}.
          </HelpText>) : ''}
        {mediaLoadError ? (
          <HelpText type="danger">
            {_.get(mediaLoadError, 'message', 'error loading media')}
          </HelpText>
        ) : ''}
      </Results>
    );
  }
}
